import { useState } from "react";
import { Menu, X } from "lucide-react";
import { LOGO_URL, NAV_LINKS, BRAND } from "@/lib/constants";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/90 border-b border-neutral-200"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-24 flex items-center justify-between">
        <a
          href="#top"
          data-testid="header-logo"
          className="flex items-center group"
        >
          <img
            src={LOGO_URL}
            alt="Rosenberg Objektservice"
            className="h-16 sm:h-20 w-auto object-contain"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="text-sm font-medium text-[#0A0A0A] hover:text-[#8A151B] transition-colors uppercase tracking-wider"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#kontakt"
          data-testid="header-cta-button"
          className="hidden lg:inline-flex bg-[#8A151B] text-white hover:bg-[#6B1015] px-6 py-3 font-semibold tracking-wide transition-colors duration-300 uppercase text-sm"
        >
          Anfrage stellen
        </a>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden p-2 text-[#0A0A0A]"
          aria-label="Menü"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-white border-t border-neutral-200"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base font-medium text-[#0A0A0A] uppercase tracking-wider"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#kontakt"
              onClick={() => setOpen(false)}
              className="bg-[#8A151B] text-white px-6 py-3 font-semibold tracking-wide text-center uppercase text-sm"
            >
              Anfrage stellen
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
